import type { Map as MLMap } from 'maplibre-gl';
import type { LngLat } from '../shared/types';

/**
 * 地図の長押し（タッチ）と右クリック（マウス）。
 * iPhone の Safari / Chrome は長押しで contextmenu を出さないので、タッチは自前で判定する。
 * Android は長押しで contextmenu も出るので、二重に呼ばないようにする
 */
export function onLongPress(map: MLMap, cb: (p: LngLat) => void, ms = 550): void {
  let timer = 0;
  let start: { x: number; y: number } | null = null;
  let firedAt = 0;
  const cancel = () => {
    clearTimeout(timer);
    start = null;
  };

  map.on('touchstart', (e) => {
    cancel();
    if (e.originalEvent.touches.length !== 1) return; // ピンチなど
    start = { x: e.point.x, y: e.point.y };
    const p: LngLat = [e.lngLat.lng, e.lngLat.lat];
    timer = window.setTimeout(() => {
      start = null;
      firedAt = Date.now();
      cb(p);
    }, ms);
  });
  map.on('touchmove', (e) => {
    if (!start) return;
    if (e.originalEvent.touches.length !== 1 || Math.hypot(e.point.x - start.x, e.point.y - start.y) > 10) cancel();
  });
  map.on('touchend', cancel);
  map.on('touchcancel', cancel);
  map.on('dragstart', cancel);

  map.on('contextmenu', (e) => {
    if (Date.now() - firedAt < 1500) return;
    cb([e.lngLat.lng, e.lngLat.lat]);
  });
}
